import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=ae7edbaa&"
var script = {}
import style0 from "./SignupPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports